import { type Message } from 'entities/Message/model/Message'
import { type RowCreditUsage } from 'entities/Analytics/model/Table/RowCreditUsage'
import { type IOpenContactsDetails } from 'widgets/ContactsDetails'
import { CreditUsageMessageModalStore } from 'pages/analytics/pages/creditUsage/ui/CreditUsageMessageModal'

export const getRowActions = (
  row: RowCreditUsage,
  getMessage: (id: number) => Message | undefined,
  onOpenContactsDetails: IOpenContactsDetails
) => {
  const actions = []
  if (row.origin.details?.message) {
    actions.push({
      text: 'See message',
      icon: 'messageTextCircle02' as const,
      onAction: () => {
        const message = getMessage(row.id)
        if (message) {
          const modalStore = new CreditUsageMessageModalStore(row.origin, message)
          modalStore.openModal()
        }
      },
    })
  }
  if (row.openContactsDetailsData) {
    actions.push({
      text: 'Go to conversation',
      icon: 'conversation' as const,
      onAction: () => {
        if (row.openContactsDetailsData) {
          return onOpenContactsDetails.open(row.openContactsDetailsData)
        }
      },
    })
  }

  return actions
}
